// Design decisions (intentional — do not "fix" without reading these):
//
// 1. Merchant theming exemption: this overlay is shadow-DOM isolated and is a
//    developer-facing diagnostic tool. It is intentionally EXEMPT from merchant
//    (getCssTheme) theming — the merchant's global stylesheet cannot reach
//    shadow-root content anyway, and the overlay must render consistently
//    regardless of merchant branding. The `ottu__sdk-diagnostics-*` classes below
//    are this shadow stylesheet's own hooks, NOT merchant-theme classes.
//
// 2. Local escapeHtml is a deliberate entity-encoder (encodes & < > "). It is NOT
//    security.js's escapeHtml, which is a DOMPurify tag-stripper (ALLOWED_TAGS:[])
//    that neither entity-encodes < > nor escapes " — and is therefore unsafe for
//    interpolating values into HTML attribute contexts, as this template does.
//    Do not delegate to security.js here.
const ICONS = { pass: '✓', fail: '✗', warn: '⚠', info: 'ⓘ' };
const HOST_ID = 'ottu-sdk-diagnostics';

function escapeHtml(str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function renderRow(check) {
  return `<div class="ottu__sdk-diagnostics-row" data-testid="ottu-sdk-diagnostics-row-${escapeHtml(check.id)}">
    <span class="ottu__sdk-diagnostics-icon ottu__sdk-diagnostics-${escapeHtml(check.status)}">${ICONS[check.status] || ''}</span>
    <span class="ottu__sdk-diagnostics-id">${escapeHtml(check.id)}</span>
    <span class="ottu__sdk-diagnostics-detail">${escapeHtml(check.detail || '')}</span>
  </div>`;
}

function renderDebugOverlay(report, doc = document) {
  const previous = doc.getElementById(HOST_ID);
  if (previous) {
    previous.remove();
  }

  const host = doc.createElement('div');
  host.id = HOST_ID;
  host.setAttribute('data-testid', 'ottu-sdk-diagnostics');
  const shadow = host.attachShadow({ mode: 'open' });

  shadow.innerHTML = `
    <style>
      .ottu__sdk-diagnostics-panel { position: fixed; bottom: 16px; right: 16px; z-index: 2147483647;
        font: 13px/1.4 system-ui, sans-serif; background: #fff; color: #111; border: 1px solid #ddd;
        border-radius: 8px; box-shadow: 0 4px 16px rgba(0,0,0,.15); padding: 12px; max-width: 360px; }
      .ottu__sdk-diagnostics-row { display: flex; gap: 8px; align-items: baseline; padding: 3px 0; }
      .ottu__sdk-diagnostics-id { font-weight: 600; text-transform: uppercase; font-size: 11px; }
      .ottu__sdk-diagnostics-fail { color: #c0392b; }
      .ottu__sdk-diagnostics-warn { color: #e67e22; }
      .ottu__sdk-diagnostics-pass { color: #27ae60; }
      .ottu__sdk-diagnostics-copy { margin-top: 10px; width: 100%; padding: 6px; cursor: pointer; }
    </style>
    <div class="ottu__sdk-diagnostics-panel">
      <div class="ottu__sdk-diagnostics-header">Ottu SDK — Diagnostics</div>
      ${(report.checks || []).map(renderRow).join('')}
      <button class="ottu__sdk-diagnostics-copy" data-testid="ottu-sdk-diagnostics-copy">Copy JSON report</button>
    </div>`;

  const button = shadow.querySelector('[data-testid="ottu-sdk-diagnostics-copy"]');
  button.addEventListener('click', () => {
    const text = JSON.stringify(report, null, 2);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text);
    }
  });

  doc.body.appendChild(host);
  return host;
}

module.exports = { renderDebugOverlay, escapeHtml };
